// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../stores/MainStore';

// Components
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

interface State {
  open: boolean;
}

interface Props {
  open: boolean;
  text: string;
  className: string;
}

/**
 * @description Notification View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class Notification extends React.Component<Props, State> {

  /**
   * Creates an instance of Notification.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);
    this.state = {
      open: this.props.open
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      open: nextProps.open
    });
  }

  hideNotification = () => {
    this.setState({ open: false });
    MainStore.hideNotification();
  }

  handleClose = () => {
    return (event: React.MouseEvent<any>, reason: any) => {
      if (reason === "clickaway") {
        return;
      }

      this.hideNotification();
    };
  }

  /**
   * @description Render the NotificationView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const { text, className } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom'
        }}
        open={this.state.open}
        autoHideDuration={6000}
        className={className}
        onClose={this.handleClose()}
        message={< span id="message-id" > {text}</span >}
        action={
          [
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={() => this.hideNotification()}>
              <Icon>close</Icon>
            </IconButton>
          ]}
      />
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/components/Notification.tsx